import React from "react";

import styles from "./Toggle.module.scss";
import classNames from "classnames";

interface IToggleProps {
    className?: string,
    isChecked: boolean,
    disabled?: boolean,
    toggleHandler: (isChecked: boolean) => void,
    name?: string
}

const Toggle: React.FC<IToggleProps> = ({
    className = "",
    isChecked,
    disabled = false,
    toggleHandler,
    name,
}) => {
    
    const onChangeHandler = () => {
        toggleHandler(!isChecked);
    }

    return (
        <label
            className={classNames(`${styles.toggle} ${isChecked ? styles.toggleActive : ""} ${className}`, (disabled ? (isChecked ? '!bg-[#98bcf1]' : '!bg-[#E2E8F0]') : ''))}
        >
            <input
                aria-label={"toggle"}
                name={name}
                className={classNames(styles.toggleHidden, (disabled ? '!bg-[#E2E8F0]' : ''))}
                onChange={onChangeHandler}
                type={"checkbox"} 
                checked={isChecked}
                disabled={disabled}
            />
        </label>
    )

}

export default Toggle;